import apiClient from '../axios.js';

/**
 * Google Calendar 整合 API
 */
export const calendarService = {
  /**
   * 取得 OAuth 授權 URL
   * @param {string} storeId - 門市 ID
   * @returns {Promise<Object>} 授權 URL
   */
  getAuthUrl: async (storeId) => {
    const response = await apiClient.get(`/stores/${storeId}/calendar/authorize-url`);
    return response;
  },

  /**
   * 處理 OAuth 授權回調（已廢棄，改用後端直接處理回調）
   * @param {string} storeId - 門市 ID
   * @param {string} code - Authorization code
   * @returns {Promise<Object>} 授權結果
   */
  authorize: async (storeId, code) => {
    const response = await apiClient.post(`/stores/${storeId}/calendar/authorize`, { code });
    return response;
  },

  /**
   * 查詢日曆設定
   * @param {string} storeId - 門市 ID
   * @returns {Promise<Object>} 日曆設定
   */
  getStoreCalendarConfig: async (storeId) => {
    const response = await apiClient.get(`/stores/${storeId}/calendar/config`);
    return response;
  },

  /**
   * 更新日曆設定
   * @param {string} storeId - 門市 ID
   * @param {Object} configData - 設定資料
   * @returns {Promise<Object>} 更新結果
   */
  updateStoreCalendarConfig: async (storeId, configData) => {
    const response = await apiClient.put(`/stores/${storeId}/calendar/config`, configData);
    return response;
  },

  /**
   * 批次同步
   * @param {string} storeId - 門市 ID
   * @param {Object} syncData - 同步資料
   * @returns {Promise<Object>} 同步結果
   */
  manualSyncCalendar: async (storeId, syncScope = 30) => {
    const response = await apiClient.post(`/calendar/configs/${storeId}/sync`, { syncScope });
    return response;
  },

  /**
   * 查詢同步狀態
   * @param {string} storeId - 門市 ID
   * @returns {Promise<Object>} 同步狀態
   */
  getSyncStatus: async (storeId) => {
    const response = await apiClient.get(`/stores/${storeId}/calendar/sync-status`);
    return response;
  },

  /**
   * 查詢同步紀錄
   * @param {Object} params - 查詢參數
   * @returns {Promise<Object>} 同步紀錄列表
   */
  getSyncLogs: async (params = {}) => {
    const response = await apiClient.get(`/calendar/sync-logs`, { params });
    return response;
  },

  /**
   * 取得日曆連結
   * @param {string} storeId - 門市 ID
   * @returns {Promise<Object>} 日曆連結
   */
  getCalendarLinks: async (storeId) => {
    const response = await apiClient.get(`/stores/${storeId}/calendar/links`);
    return response;
  },

  // 以下為向後兼容的別名方法
  getConfig: async (storeId) => {
    return calendarService.getStoreCalendarConfig(storeId);
  },

  updateConfig: async (storeId, configData) => {
    return calendarService.updateStoreCalendarConfig(storeId, configData);
  },

  batchSync: async (storeId, syncData) => {
    const syncScope = syncData?.syncScope || 30;
    return calendarService.manualSyncCalendar(storeId, syncScope);
  }
};
